import {
  startOfWeek,
  isThisWeek,
  differenceInDays,
  format
} from 'date-fns'
const formatTime = (date: Date, isFullDate: boolean = false, isFullTime: boolean = false): string => {
  const day = '0' + date.getDate()
  const month = '0' + date.getMonth()
  const hours = date.getHours()
  // Minutes part from the timestamp
  const minutes = '0' + date.getMinutes()
  // Seconds part from the timestamp
  const formattedTime = hours + ':' + minutes.substr(-2)
  if (isFullDate) {
    const fullDate = `${day.substr(-2)}.${month.substr(-2)}.${date.getFullYear()}`
    return isFullTime ? fullDate + ' ' + formattedTime : fullDate
  }
  return formattedTime
}

export const ConvertDateTime = (datetime: string): string => {
  const date = new Date(datetime)
  const currentDatetime = new Date()
  const startWeek = startOfWeek(currentDatetime,{ weekStartsOn: 1 })
  const dateDifference = differenceInDays(currentDatetime, date)
  const thisWeek = isThisWeek(date, { weekStartsOn: 1 })
  if (dateDifference > 0) {
    if (dateDifference === 1) {
      return 'Yesterday'
    }
    if (thisWeek) {
      return date.toLocaleDateString('en', { weekday: 'long' })
    }
    if (date < startWeek) {
      return format(date, 'dd.MM.yyyy')
    }
  }
  return formatTime(date)
}
